class ProductFeatures extends HTMLElement {
  constructor() {
    super();
    // Ensure the element is fully initialized
    if (this.isConnected) {
      this.init();
    }
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.tabs = this.querySelectorAll(".tab");
    this.panels = this.querySelectorAll(".tab-panel");

    this.tabs.forEach((tab) => {
      tab.addEventListener("click", (e) => this.onTabClick(e, tab));
    });
  }

  onTabClick(evt, tab) {
    this.panels.forEach((panel) => {
      panel?.classList.add("hidden");
    });

    this.tabs.forEach((t) => {
      t?.classList.remove("active");
    });

    tab?.classList.add("active");
    const panelId = tab.getAttribute("aria-controls");
    const panel = this.querySelector(`#${panelId}`);
    panel?.classList.remove("hidden");
  }
}

customElements.define("product-features", ProductFeatures);
